if (!customElements.get('kama-whatsapp')) {
  customElements.define('kama-whatsapp', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const prompt = this.querySelector('.kama-chat__prompt');
      const link = this.querySelector('.kama-chat__link');
      const storageKey = 'kama-chat-prompt-seen-v1';
      const remember = () => {
        window.kamaChatPromptSeen = true;
        try { sessionStorage.setItem(storageKey, '1'); } catch {}
      };
      let seen = window.kamaChatPromptSeen;
      try { seen ||= sessionStorage.getItem(storageKey) === '1'; } catch {}
      const dismiss = () => {
        clearTimeout(this.promptTimer);
        if (prompt) prompt.hidden = true;
        remember();
      };
      const closeKey = 'kama-chat-widget-closed-v1';
      try { this.classList.toggle('kama-chat--dismissed', sessionStorage.getItem(closeKey) === '1'); } catch {}
      let close = this.querySelector('.kama-chat__close');
      if (!close) {
        close = document.createElement('button');
        close.className = 'kama-chat__close';
        close.type = 'button';
        close.setAttribute('aria-label', 'Close WhatsApp chat');
        close.innerHTML = '<span aria-hidden="true">×</span>';
        this.append(close);
      }
      close.addEventListener('click', () => {
        dismiss();
        this.classList.add('kama-chat--dismissed');
        try { sessionStorage.setItem(closeKey, '1'); } catch {}
      }, { signal });
      this.querySelector('.kama-chat__dismiss')?.addEventListener('click', () => {
        dismiss();
        link.focus({ preventScroll: true });
      }, { signal });
      if (prompt && !seen && !window.Shopify?.designMode) {
        const reveal = () => {
          if (this.classList.contains('kama-chat--dismissed')) return;
          if (document.hidden || getComputedStyle(this).visibility === 'hidden') {
            this.promptTimer = setTimeout(reveal, 2000);
            return;
          }
          prompt.hidden = false;
          remember();
        };
        this.promptTimer = setTimeout(reveal, Number(this.dataset.promptDelay || 8) * 1000);
      }
      link.addEventListener('click', () => {
        dismiss();
        try {
          const result = window.Shopify?.analytics?.publish('kama_whatsapp_click', {
            placement: 'floating_widget', page_type: this.dataset.pageType,
            device: matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
          });
          Promise.resolve(result).catch(() => {});
        } catch {}
      }, { signal });
      const position = () => {
        let offset = 0;
        const own = this.getBoundingClientRect();
        document.querySelectorAll('.sticky-add-to-cart__bar[data-stuck="true"]').forEach(bar => {
          if (!bar.getClientRects().length) return;
          const rect = bar.getBoundingClientRect();
          if (rect.top >= window.innerHeight / 2 && rect.right > own.left && rect.left < own.right) {
            const bottom = parseFloat(getComputedStyle(bar).bottom) || 0;
            offset = Math.max(offset, rect.height + bottom + 12);
          }
        });
        this.style.setProperty('--chat-buy-offset', `${offset}px`);
        const overlapsPurchase = [...document.querySelectorAll('.kp-purchase :is(button, input, select, [data-kama-wish-save]), .kg-support-videos :is(iframe, a)')].some(control => {
          if (!control.getClientRects().length) return false;
          const rect = control.getBoundingClientRect();
          return rect.bottom > own.top && rect.top < own.bottom && rect.right > own.left && rect.left < own.right;
        });
        this.classList.toggle('kama-chat--purchase-overlap', overlapsPurchase);
      };
      const schedule = () => {
        cancelAnimationFrame(this.positionFrame);
        this.positionFrame = requestAnimationFrame(position);
      };
      this.observer = new MutationObserver(schedule);
      this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-stuck', 'data-variant-available'] });
      this.resizeObserver = new ResizeObserver(schedule);
      document.querySelectorAll('.sticky-add-to-cart__bar').forEach(bar => this.resizeObserver.observe(bar));
      window.addEventListener('resize', schedule, { signal });
      window.addEventListener('scroll', schedule, { signal, passive: true });
      window.visualViewport?.addEventListener('resize', schedule, { signal });
      position();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.promptTimer);
      cancelAnimationFrame(this.positionFrame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}

